'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import styled from '@emotion/styled';

const _ = {
    filter: require('lodash/filter'),
    find: require('lodash/find'),
    findIndex: require('lodash/findIndex'),
    forEach: require('lodash/forEach'),
    isEmpty: require('lodash/isEmpty'),
    map: require('lodash/map'),
    reject: require('lodash/reject'),
    uniq: require('lodash/uniq'),
};

const ServerRequest = require('../../actions/request');
const KeyboardUtil = require('../../util/keyboard');
const verUtil = require('../../util/version.js');
import SortableTable2 from '../table/SortableTable2';
import ErrorBox from '../common/ErrorBox';
import AccessibleIcon from '../common/AccessibleIcon';
import AutoSizeTextArea from '../common/AutoSizeTextArea';
import LoadingMainContent from '../loading/LoadingMainContent';

let EditDiv = styled.div`
    padding: 1rem 3rem;
    margin: 1rem;
    background: lightgrey;
    border: solid thin grey;
    textarea {
        display: block;
        width: 100%;
    }
`;

let HistoryDiv = styled.div`
    padding: 1rem 3rem;
    margin: 1rem;
    background: white;
    border: solid thin grey;
    textarea {
        display: block;
        width: 100%;
    }
`;

let DeletedTextSpan = styled.span`
    color: orange;
`;

class AdminTemplateBoilerplate extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            // the only current template with boilerplate
            app_key: 'sfc', 
            app_name: 'Smart Chat',
            version: '1.0.0',
            selected_index: null,
            rows: [],
            unique_versions: [],
            loading: true,
            loading_history: true,
            saving: false,
        };
        this.unsubscribes = [
            // RegisterStore.listen(this.onRegisterStoreStateChange.bind(this))
        ];
    }
    
    componentDidMount() {
        this.requestBoilerplate();
    }
    
    requestBoilerplate=()=>{
        const appKey = this.state.app_key;
        const version = this.state.version;
        let body = {
            appKey,
            version,
            // playbooks: undefined
        };
        // load the boilerplate
        let url = `/authoring/template_boilerplate?vm=all`;
        ServerRequest.makeRequest(url, 'POST',JSON.stringify(body))
        .then((template_boilerplate)=>{
            let unique_versions = _.uniq(_.map(template_boilerplate,'version'));
            let rows = _.map(template_boilerplate,(row,i)=>{
                return { ...row, changed: false };
            });
            this.setState({rows, unique_versions, loading:false},()=>{
                this.requestBoilerplateHistory();
            });
        })
        .catch((error)=>{
            this.setState({loading:false, error});
        });
    }

    requestBoilerplateHistory=()=>{
        const template_key = this.state.app_key;

        // get boilerplate history
        let url = `/authoring/template_boilerplate_history/${template_key}`;
        ServerRequest.makeRequest(url, 'GET')
        .then((historyRows)=>{
            let row_history = [];
            _.forEach(this.state.rows,(row,i)=>{
                let { string_id, version } = row;
                let hrs =_.filter(historyRows,{string_id,version});
                hrs = _.map(hrs,(hr)=>{
                    let { prior_string_value: string_value, change_date:when, prior_user: by } = hr;
                    return { string_value, by, when };
                });
                //console.log(`hist for index ${i+1}:`,hrs);
                row_history.push({
                    string_id, version, 
                    hist: hrs,
                });
            });
            console.log("clearing loading_history");
            this.setState({
                loading_history:false,
                row_history
            });
        })
        .catch((error)=>{
            this.setState({loading_history:false, error});
        });
    }


    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }
    
    // onRowClick(e, index) {
    //     this.setState({ selected_index: index});
    // }
    
    doSetBoilerplate=(row)=>{
        let {
            string_id, version, string_value, 
            restore_string_value, // state value for deleting and restoring a row within this component
        } = row;
        if (string_value) {
            restore_string_value = string_value; // make sure this stays around
        }
        const usageData = {
            channelId: null,
            activityId: null,
            shareId: null,
            shortCourseId: null,
        };
        const data = {
            template_key: this.state.app_key, 
            version, string_id, string_value, 
            usageData,
        };
        
        this.setState({saving:true, error: null},()=>{
            let url = `/authoring/template_boilerplate/${data.template_key}`;
            ServerRequest.makeRequest(url, 'PUT', JSON.stringify(data))
            .then((result)=>{
                let rows = this.state.rows.slice();
                let query = {string_id,version};
                let i = _.findIndex(rows,query);
                let archived = false;
                if (string_value === null) { // indicates we should delete the string value
                    archived = true;
                }
                if (i>=0) {
                    rows[i] = {...rows[i], string_value, archived, changed: false, restore_string_value};
                }
                else {
                    console.log(`did not find row matching ${JSON.stringify(query)}`);
                }
                this.setState({saving:false, rows});
            })
            .catch((error)=>{
                this.setState({saving:false, error});
            })
        });
    }
    
    copyBoilerplate=(rows)=>{
        rows = _.map(rows,(row)=>({
            string_id: row.string_id,
            version: row.version,
            string_value: row.string_value,
        }));
        let textToCopy = JSON.stringify(rows);
        var $temp = $("<input>");
        $("body").append($temp);
        $temp.val(textToCopy).select();
        document.execCommand("copy");
        $temp.remove();
        this.setState({copied:true},()=>{
            setTimeout(()=>{
                this.setState({copied:false});
            },5000);
        });
    }
    
    pasteBoilerplate=()=>{
        return navigator.clipboard.readText()
        .then((text)=>{
            try {
                let rows = this.state.rows.slice();
                let new_rows = JSON.parse(text);
                let error;
                _.forEach(new_rows,(row)=>{
                    let {string_id,version,string_value,...theRest} = row;
                    if ((typeof string_id !== 'string') || 
                        (typeof version !== 'string') ||
                        (typeof string_value !== 'string')) {
                        error = new Error("invalid clipboard contents");
                        return false;
                    }
                    if (theRest && !_.isEmpty(theRest)) {
                        console.log("clipboard element had extra values:",theRest);
                    }
                    let i = _.findIndex(rows,{string_id,version});
                    let old_row = rows[i];
                    if (old_row) {
                        if (old_row.string_value !== string_value) {
                            rows[i] = {...rows[i], string_value, changed: true };
                        }
                    }
                    else {
                        rows.push({string_id,version,string_value,changed:true}); // new row
                    }
                });
                if (error) {
                    this.setState({error});
                }
                else {
                    this.setState({rows});
                }
            }
            catch(err) {
                console.log("pasteBoilerplate error",err);
            }
        });
    }
    
    editRow=(index)=>{
        let row = this.state.rows[index-1];
        if (!row) {
            return;
        }
        this.setState({editIndex:index, historyIndex:null, edited_string_value: row.string_value});
    }
    
    viewHistory=(index)=>{
        let row = this.state.rows[index-1];
        if (!row) {
            return;
        }
        this.setState({historyIndex:index, editIndex:null});
    }
    
    closeHistory=()=>{
        this.setState({historyIndex:null});
    }
    
    revertToHistoricValue=(stringValue)=>{
        if (!this.state.historyIndex) {
            return;
        }
        let i = this.state.historyIndex - 1; // actual index rather than display index
        let rows = this.state.rows.slice();
        if (!rows[i]) {
            return;
        }
        rows[i].changed = true;
        rows[i].string_value = stringValue;
        this.setState({rows,historyIndex:null}); // close the history panel
    }
    
    onChangeEditRow=(e)=>{
        this.setState({edited_string_value: e.target.value});
    }

    closeEditRow=(save)=>{
        const index = this.state.editIndex;
        if (!save) {
            this.setState({editIndex:null});
            return;
        }
        let i = index - 1; // actual index rather than display index
        let rows = this.state.rows.slice();
        if (!rows[i]) {
            this.setState({editIndex:null});
            return;
        }
        rows[i].changed = true;
        rows[i].string_value = this.state.edited_string_value;
        this.setState({rows,editIndex:null});
    }

    saveRow=(index)=>{
        let i = index - 1; // actual index rather than display index
        let row = this.state.rows[i];
        if (!row) {
            return;
        }
        this.doSetBoilerplate(row);
    }

    restoreRow=(index)=>{
        let i = index - 1; // actual index rather than display index
        let rows = this.state.rows.slice();
        let row = rows[i];
        if (!row) {
            return;
        }
        row.changed = true;
        row.string_value = row.string_value || row.restore_string_value;
        row.archived = false;
        rows[i] = {...row};
        this.setState({rows});
    }

    deleteRow=(index)=>{
        let i = index - 1; // actual index rather than display index
        let row = this.state.rows[i];
        if (!row) {
            return;
        }
        let restore_string_value = row.string_value;
        if (restore_string_value === null) { 
            return;
        }
        if (confirm("Are you sure you want to delete this entry?")) {
            row = { ...row, string_value: null, restore_string_value }; // indicate delete
            this.doSetBoilerplate(row);
        }
    }
    
    selectVersion=(e)=>{
        this.setState({ selected_version: e.target.value});
    }
    
    setExclusiveVersion=(e)=>{
        this.setState({ exclusive_version: e.target.checked });
    }
    
    render() {
        if (this.state.loading) {
            return (
                <LoadingMainContent />
            )
        };
        console.log("render loading_history:",this.state.loading_history);

        // onRowClick={this.onRowClick}
        let editRow = this.state.editIndex && this.state.rows[this.state.editIndex-1];
        let selected_version = this.state.selected_version;
        let rows = _.map(this.state.rows,(row,i)=>{
            let {string_id,version} = row;
            let hr = _.find(this.state.row_history,{string_id,version});
            // console.log(`hr for map at ${string_id} ${version}:`,hr);
            
            return {
                ...row,
                index:i+1, // set index for rows
                hist: hr && hr.hist, // history (if any)
            }
            // set index for rows
        }); 
        let historyRow = this.state.historyIndex && rows[this.state.historyIndex-1];

        let versionText = '';
        if (selected_version) {
            if (this.state.exclusive_version) {
                versionText = ` version ${selected_version}`;
                rows = _.filter(rows,{version:selected_version});
            }
            else {
                versionText = ` version ${selected_version} or earlier`;
                let v = verUtil.parseVersion(selected_version);
                rows = _.filter(rows,(r)=>{
                    let c = v.compare(r.version);
                    return (c>=0);
                });
            }
        }
        
        
        return (
            <div>
                <ErrorBox error={this.state.error} />
                { editRow ? 
                <EditDiv>
                    <div className="row">
                        <label>{'String ID:'}</label>
                        <span>{editRow.string_id}</span>
                    </div>
                    <div className="row">
                        <label>{'Version:'}</label>
                        <span>{editRow.version}</span>
                    </div>
                    <div className="row">
                        <label>{'String:'}</label>
                        <AutoSizeTextArea value={this.state.edited_string_value} disabled={this.state.saving} onChange={this.onChangeEditRow}/>
                    </div>
                    <Button onClick={this.closeEditRow.bind(this,true)}>
                        Done
                    </Button>
                    <Button onClick={this.closeEditRow.bind(this,false)}>
                        Cancel
                    </Button>
                </EditDiv>
                : null }
                
                { historyRow ? 
                <HistoryDiv>
                    <Button onClick={this.closeHistory}>
                        Close History
                    </Button>
                    <SortableTable2 key="raw-data-table2"
                        title={`History for ${historyRow.string_id} ${historyRow.version}`}
                        rows={historyRow.hist}
                        columns={
                            [
                                {
                                    displayName: 'Author',
                                    key:'by',
                                    width: '20%',
                                    type: 'string'
                                },
                                {
                                    displayName: 'Date',
                                    key:'when',
                                    width: '20%',
                                    type: 'date'
                                },
                                {
                                    displayName: 'Value',
                                    key:'string_value',
                                    width: '60%',
                                    type: 'string'
                                }
                            ]
                        }
                        displayColumnCallbacks={{
                            string_value: (string_value)=>{
                                return ( 
                                    <div>
                                        <AutoSizeTextArea readOnly value={string_value} />
                                        <button className="table-button" title="revert" disabled={this.state.saving} onClick={()=>{
                                                this.revertToHistoricValue(string_value)
                                                }}>
                                            Revert To This String
                                        </button>
                                    </div>
                                )
                            }
                        }}
                    
                    />
                </HistoryDiv>
        
                : null }
                { (this.state.unique_versions && this.state.unique_versions.length > 1) ?
                <label>{'version:'}
                    <select value={this.state.selected_version || ''} onChange={this.selectVersion}>
                        <option key={'all'} value={''}>{'all'}</option>
                    {_.map(this.state.unique_versions,(version)=>(
                        <option key={version} value={version}>{version}</option>
                    ))}
                    </select>
                </label>
                : null }
                { this.state.selected_version ? 
                <label>
                    <input type="checkbox" checked={this.state.exclusive_version} onChange={this.setExclusiveVersion}/>
                    {'only'}
                </label>
                : null }
                <Button onClick={this.copyBoilerplate.bind(this,rows)} disabled={this.state.copied}>
                    {this.state.copied ? "Rows copied to clipboard" : "Copy to clipboard"}
                </Button>
                <Button onClick={this.pasteBoilerplate}>
                    Paste from clipboard
                </Button>
                <SortableTable2
                    key="raw-data-table"
                    title={`AI boilerplate strings for ${this.state.app_name}${versionText}`}
                    uniqueRowKey="index"
                    rows={rows}
                    selectedRowKey={this.state.selected_index}
                    columns={
                        [
                            {
                                displayName: 'index',
                                key:'index',
                                size: 1,
                                type: 'number'
                            },
                            {
                                displayName: 'Version',
                                key:'version',
                                size: 1,
                                type: 'string'
                            },
                            {
                                displayName: 'String ID',
                                key:'string_id',
                                size: 1,
                                type: 'string'
                            },
                            {
                                displayName: 'String',
                                key:'string_value',
                                size: 20,
                                type: 'custom'
                            },
                            {
                                displayName: 'Changed',
                                key:'changed',
                                size: 1,
                                type: 'custom'
                            },
                            {
                                displayName: 'Edit',
                                key:'edit',
                                size: 1,
                                type: 'custom'
                            },
                            {
                                displayName: 'Delete',
                                key:'delete_entry',
                                size: 1,
                                type: 'custom'
                            },
                            {
                                displayName: 'History',
                                key:'hist',
                                size: 1,
                                type: 'custom'
                            },
                        ]
                    }
                    displayColumnCallbacks={{
                        string_value: (dummy,index)=>{
                            let row = rows[index-1];
                            let archived = row && row.archived;
                            if (archived) {
                                return (<DeletedTextSpan>{'(archived)'}</DeletedTextSpan>);
                            }
                            return (<span>{row && row.string_value}</span>);
                        },
                        changed: (changed,index)=>{
                            if (changed) {
                                return (
                                    <button className="table-button" disabled={this.state.saving} title="edit" onClick={()=>{this.saveRow(index)}}>
                                        Save
                                    </button>
                                )
                            }
                            return ( <span>{'unchanged'}</span> );
                        },
                        edit: (dummy,index)=>{
                            return (
                                <button className="table-button" title="edit" disabled={this.state.saving} onClick={()=>{this.editRow(index)}}>
                                    <AccessibleIcon className="fa fa-pencil table-button" label="edit string">
                                        Edit
                                    </AccessibleIcon>
                                </button>
                            )
                        },
                        delete_entry: (dummy,index)=>{
                            if (this.state.saving) {
                                return null;
                            }
                            let row = rows[index-1];
                            let archived = row && row.archived;
                            if (archived) {
                                return (
                                    <button className="table-button" title="edit" onClick={()=>{this.restoreRow(index)}}>
                                        <AccessibleIcon className="fa fa-undo table-button" label="restore entry">
                                            Restore
                                        </AccessibleIcon>
                                    </button>
                                )
                            }
                            return (
                                <button className="table-button" title="edit" disabled={this.state.saving} onClick={()=>{this.deleteRow(index)}}>
                                    <AccessibleIcon className="fa fa-trash table-button" label="delete entry">
                                        Delete
                                    </AccessibleIcon>
                                </button>
                            )
                        },
                        hist: (dummy,index)=>{
                            if (this.state.loading_history) {
                                return ( <span className="fa fa-refresh fa-spin"/> );
                            }
                            let row = rows[index-1];
                            if (!row) {
                                return ( <span>{'not found'}</span> );
                            }
                            let hist = row.hist;
                            // console.log("hist:",index,hist,row);
                            return (
                                <button className="table-button" title="history" disabled={!hist || !hist.length} onClick={()=>{this.viewHistory(index)}}>
                                    {`History(${hist ? hist.length : "0"})`}
                                </button>
                            )
                        },
                    }}
                    
                />
            </div>
        );
    }
}

//AdminTemplateBoilerplate.propTypes = {};
//AdminTemplateBoilerplate.defaultProps = {};

export default AdminTemplateBoilerplate;
